import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const Registration: React.FC = () => {
  return (
    <Container className="py-5">
      <h1 className="text-navy fw-bold mb-4 text-center">Registration</h1>
      <p className="lead text-center mb-5">
        Join the 515 Soccer Academy family! Select a program below to register.
      </p>

      <Row className="justify-content-center g-4">
        {/* Academy Registration */}
        <Col md={6} lg={5}>
          <Card className="h-100 shadow-sm border-0">
            <Card.Header className="bg-teal text-white text-center py-3">
              <h3 className="m-0 fw-bold">Academy (U9-U10)</h3>
            </Card.Header>
            <Card.Body className="d-flex flex-column text-center p-4">
              <Card.Text className="mb-4">
                For players born in 2016-2017. Focus on individual ball mastery, confidence, and fun.
              </Card.Text>
              <div className="mt-auto">
                <Button 
                    variant="primary" 
                    className="btn-lg w-100 text-white mb-2" 
                    href="https://forms.gle/GSJYG4XhVV6uUnHC8"
                    target="_blank"
                >
                  Register for Academy
                </Button>
                <small className="text-muted d-block">via Google Forms</small>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Select Registration */}
        <Col md={6} lg={5}>
          <Card className="h-100 shadow-sm border-0">
            <Card.Header className="bg-navy text-white text-center py-3">
              <h3 className="m-0 fw-bold">Select (U11+)</h3>
            </Card.Header>
            <Card.Body className="d-flex flex-column text-center p-4">
              <Card.Text className="mb-4">
                For players born in 2015 and older. Competitive play with a focus on long-term development.
              </Card.Text>
              <div className="mt-auto">
                <Button
                    variant="secondary"
                    className="btn-lg w-100 mb-2"
                    href="https://forms.gle/fM3781HwpHVgDdy68"
                    target="_blank"
                >
                  Select Interest Form
                </Button>
                <p className="small text-muted mb-0">
                    Now accepting interest for the <strong>2026-27 season</strong>. <br/>
                    A coach will be in touch about practicing with us &mdash; no formal tryout schedule.
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="text-center mt-5 p-4 bg-light rounded">
        <h4>Need Financial Assistance?</h4>
        <p>We believe financial barriers should not prevent a child from playing.</p>
        <a href="https://forms.gle/QqQCD3JArjrdNYVf7" target="_blank" rel="noreferrer" className="btn btn-link fw-bold">
          Apply for Financial Aid &rarr;
        </a>
      </div>
    </Container>
  );
};

export default Registration;
